var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.externalLink(_vm.params.value))?_c('span',[_vm._v(_vm._s(_vm.params.value)+"\n    "),_c('font-awesome-icon',{attrs:{"icon":['far', 'external-link-square'],"size":"lg"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }